import { createStore } from 'zustand/vanilla';

import type { ConversationStoreState } from './types';

export const ConversationStore = createStore<ConversationStoreState>(() => ({
	activeConversationId: null,
	conversations: [],
	items: [],
	loading: false,
	thinking: false,
}));
